// angular
// .module('HeroPRO')
const HPPipelineStages = {
    Leads: {
        name: 'Leads',
        pipelineStageName: 'leads',
        pipelineStageId: 1,
    },
    Application: {
        name: 'Application',
        pipelineStageName: 'application',
        pipelineStageId: 2,
    },
    StartWork: {
        name: 'Start Work',
        pipelineStageName: 'startwork',
        pipelineStageId: 3,
    },
    GetPaid: {
        name: 'Get Paid',
        pipelineStageName: 'getpaid',
        pipelineStageId: 4,
    },
    Closed: {
        name: 'Closed',
        pipelineStageName: 'closed',
        pipelineStageId: 5,
    },
};

export default HPPipelineStages;



// WEBPACK FOOTER //
// ./src/app/config/constants/PipelineStages.constant.js